import { GEOFENCING } from '../constants';
import { ABSTRACT } from 'constants/MeshbotConstant';

/**
 * Checks if a device is a user's geofence device by validating three conditions
 * Used in subscription management to identify user-specific geofencing devices
 * that require special handling when creating or updating cloud subscriptions
 *
 * @param {Object} device - Device object to check
 * @param {string} device.subcategory - Device subcategory (must be 'geofencing')
 * @param {string} device.type - Device type (must be 'abstract')
 * @param {string} device.name - Device name (must match user UUID)
 * @param {string} userUuid - User UUID to match against device name
 * @returns {boolean} True if device is a geofence device for the specified user
 *
 * @example
 * const device = {
 *   name: 'user-123-abc',
 *   subcategory: 'geofencing',
 *   type: 'abstract'
 * };
 * isUserGeofenceDevice(device, 'user-123-abc'); // returns true
 *
 * @example
 * const regularDevice = {
 *   name: 'light-sensor',
 *   subcategory: 'sensor',
 *   type: 'device'
 * };
 * isUserGeofenceDevice(regularDevice, 'user-123-abc'); // returns false
 *
 * @example
 * // Used in SubscriptionActions.js
 * const isDeviceExist = devicesList.some((device) => {
 *   if (item.gatewayName === EZLO_GEOFENCING) {
 *     return isUserGeofenceDevice(device, item.abstractUUID);
 *   }
 *   return device.name === item.abstractUUID;
 * });
 */
export const isUserGeofenceDevice = ({ subcategory, type, name }, userUuid) =>
    name === userUuid && subcategory === GEOFENCING && type === ABSTRACT;
